// src/components/pages/CourseDetailPage.js
import React from "react";
import { useParams, Link } from "react-router-dom";
import "../../styles/course-detail.css";
import { courses } from "../../data/courses";
import { Helmet } from "react-helmet-async";

// console.log("Course category:", course.category);

export default function CourseDetailPage() {
  const { id } = useParams();
  const course = courses.find((c) => c.id === id);
  console.log("Course category:", course.category);

  if (!course) {
    return (
      <div className="course-detail-page">
        <div className="container course-detail-inner">
          <div className="course-detail-back">
            <Link to="/courses" className="back-link">
              ← Back to Courses
            </Link>
          </div>
          <h1 className="course-not-found-title">Course Not Found</h1>
          <p className="course-not-found-text">
            The course you're looking for doesn't exist or has been removed.
          </p>
          <Link to="/courses" className="btn primary">
            Browse All Courses
          </Link>
        </div>
      </div>
    );
  }

  return (
    <>
    <Helmet>
  <title>{course.title} – Drone Course by PracVerse</title>
  <link rel="icon" href="/favicon.ico" />
<link rel="shortcut icon" href="/favicon.ico" />
<link rel="apple-touch-icon" href="/favicon.ico" />

  <meta
    name="description"
    content={
      course.shortDescription ||
      "Hands-on drone education course covering practical STEM, coding and real-world drone applications."
    }
  />
  <link
    rel="canonical"
    href={`https://www.pracverse.com/courses/${course.id}`}
  />

  <meta property="og:title" content={`${course.title} – Drone Course by PracVerse`} />
  <meta
    property="og:description"
    content={
      course.shortDescription ||
      "Hands-on drone education course covering practical STEM, coding and real-world drone applications."
    }
  />
  <meta
    property="og:url"
    content={`https://www.pracverse.com/courses/${course.id}`}
  />
  <meta
    property="og:image"
    content={`https://www.pracverse.com${course.image || "/images/og-course-default.jpg"}`}
  />

  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Course",
      "name": course.title,
      "description": course.fullDescription || course.shortDescription,
      "provider": {
        "@type": "Organization",
        "name": "PracVerse",
        "url": "https://www.pracverse.com"
      },
      "audience": {
        "@type": "EducationalAudience",
        "educationalRole": course.targetAudience || "Student"
      },
      "educationalLevel": course.target || course._difficulty || undefined,
      "timeRequired": course.durationHours || undefined,
      "category": course.category || undefined,
      "url": `https://www.pracverse.com/courses/${course.id}`,
      "image": course.image
        ? `https://www.pracverse.com${course.image}`
        : undefined
    })}
  </script>
</Helmet>



    <div className="course-detail-page">
      {/* breadcrumb/back */}
      <div className="course-detail-top">
        <div className="container course-detail-inner">
          <div className="course-detail-back">
            <Link to="/courses" className="back-link">
              ← Back to Courses
            </Link>
          </div>
        </div>
      </div>

      {/* HERO SECTION (matches screenshot) */}
      <section className="course-detail-hero">
        <div className="container course-detail-inner hero-layout">
          {/* Left: image / visual */}
          <div className="course-detail-media">
            <div className="course-detail-media-card">
              {course.image ? (
                <img
                  src={course.image}
                  alt={course.title}
                  className="course-detail-image"
                />
              ) : (
                <div className="course-detail-image-placeholder">
                  <span>Course Image</span>
                </div>
              )}
            </div>
          </div>

          {/* Right: info */}
          <div className="course-detail-info">
            {/* frequency + level badges */}
            <div className="course-badges-row">
              {course.frequency && (
                <span className="badge badge-outline">{course.frequency}</span>
              )}
              {course.target && (
                <span
                  className={`badge badge-level ${course.target.toLowerCase()}`}
                >
                  {course.target}
                </span>
              )}
            </div>

            <h1 className="course-detail-title">{course.title}</h1>

            <p className="course-detail-short">{course.shortDescription}</p>

            {/* stats row */}
            <div className="course-detail-stats">
              {course.durationHours && (
                <div className="stat-block">
                  <div className="stat-icon">⏱</div>
                  <div>
                    <div className="stat-label">Duration</div>
                    <div className="stat-value">
                      {course.durationHours} hours
                    </div>
                  </div>
                </div>
              )}

              {course.targetAudience && (
                <div className="stat-block">
                  <div className="stat-icon">👥</div>
                  <div>
                    <div className="stat-label">Audience</div>
                    <div className="stat-value">{course.targetAudience}</div>
                  </div>
                </div>
              )}
            </div>

            {/* buttons */}
            <div className="course-detail-ctas">
              <Link to="/contact" className="btn primary large full-width">
                Enroll Now
              </Link>
              <Link to="/partnerships" className="btn outline large full-width">
                Partner With Us
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Overview */}
      {course.fullDescription && (
        <section className="course-overview-section">
            <div className="container course-detail-inner">
            <div className="course-overview-card">
                <h2 className="course-overview-title">Course Overview</h2>
                <p className="course-overview-text">
                {course.fullDescription}
                </p>
            </div>
            </div>
        </section>
        )}


      {/* What You'll Learn */}
        {course.highlights && course.highlights.length > 0 && (
        <section className="course-section learn-wrap">
            <div className="container course-detail-inner">
            <div className="learn-card">
                <h2 className="learn-title">What You'll Learn</h2>

                <div className="learn-grid">
                {course.highlights.map((item, idx) => (
                    <div key={idx} className="learn-item">
                    <span className="learn-icon">
                        <span className="learn-icon-inner">✔</span>
                    </span>
                    <p>{item}</p>
                    </div>
                ))}
                </div>
            </div>
            </div>
        </section>
        )}






        {/* WHY {category} LOVE THIS PROGRAM */}
        {course.description_heading && course.description_heading.length > 0 && (
<section className="course-section course-love-section">
  <div className="container course-detail-inner">
    <h2 className="course-section-title">
      Why {course.category} love this program
    </h2>

    <div className="course-love-grid">
      {course.description_heading.map((heading, idx) => (
      <article className="love-card">
        {/* <div className="love-icon">📚</div> */}
        <h3 className="love-card-title">{heading}</h3>
        <p className="love-card-text">
          {course.description[idx]}
        </p>
      </article>
      ))}
    </div>
  </div>
</section>
        )}







      {/* Final CTA */}
        <section className="course-bottom-cta">
        <div className="course-bottom-cta-inner">
            <h2 className="bottom-cta-title">Ready to Start Learning?</h2>

            <p className="bottom-cta-text">
            Join thousands of students who have already transformed their understanding
            of drone technology through our comprehensive education programs.
            </p>

            <div className="bottom-cta-actions">
            <Link to="/contact" className="btn bottom-cta-primary">
                Get Started Today
            </Link>
            <Link to="/courses" className="btn bottom-cta-secondary">
                View More Courses
            </Link>
            </div>
        </div>
        </section>

    </div>
    </>
  );
}
